var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "700" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
      _c(
        "w-scroll-view",
        { style: { minHeight: "400px" }, attrs: { tag: "div" } },
        [
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input", {
                        attrs: { label: _vm.$ct("common.title") },
                        model: {
                          value: _vm.data.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "title", $$v)
                          },
                          expression: "data.title",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("app-select-book-year", {
                        attrs: {
                          decimals: 0,
                          label: _vm.$ct("bookyear-override-optional"),
                          "add-previous-book-year-option": "",
                          "add-selected-book-year-option": "",
                        },
                        model: {
                          value: _vm.data.bookYearOverride,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "bookYearOverride", $$v)
                          },
                          expression: "data.bookYearOverride",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("w-card-title", [_vm._v(" " + _vm._s(_vm.$ct("filters")) + ": ")]),
          _vm.browse && _vm.model
            ? _c("app-human-filter-list-edit", {
                attrs: { browse: _vm.browse, model: _vm.model },
                model: {
                  value: _vm.data.filters,
                  callback: function ($$v) {
                    _vm.$set(_vm.data, "filters", $$v)
                  },
                  expression: "data.filters",
                },
              })
            : _vm._e(),
          _c("w-card-title", [
            _vm._v(" " + _vm._s(_vm.$ct("to-add-banks")) + ": "),
          ]),
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: { label: _vm.$ct("use-to-add-banks") },
                        model: {
                          value: _vm.data.useToAddBanks,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "useToAddBanks", $$v)
                          },
                          expression: "data.useToAddBanks",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.browse && _vm.model
            ? _c("app-human-filter-list-edit", {
                attrs: { browse: _vm.bankBrowse, model: _vm.bankModel },
                model: {
                  value: _vm.data.toAddBanksFilters,
                  callback: function ($$v) {
                    _vm.$set(_vm.data, "toAddBanksFilters", $$v)
                  },
                  expression: "data.toAddBanksFilters",
                },
              })
            : _vm._e(),
          _c("w-card-title", [
            _vm._v(" " + _vm._s(_vm.$ct("to-subtract-banks")) + ": "),
          ]),
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: { label: _vm.$ct("use-to-subtract-banks") },
                        model: {
                          value: _vm.data.useToSubtractBanks,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "useToSubtractBanks", $$v)
                          },
                          expression: "data.useToSubtractBanks",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.browse && _vm.model
            ? _c("app-human-filter-list-edit", {
                attrs: { browse: _vm.bankBrowse, model: _vm.bankModel },
                model: {
                  value: _vm.data.toSubtractBanksFilters,
                  callback: function ($$v) {
                    _vm.$set(_vm.data, "toSubtractBanksFilters", $$v)
                  },
                  expression: "data.toSubtractBanksFilters",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }